<template>
  <page :title="i18n.title">
    <div class="confirm-warp">
      <div class="confirm-info">
        <div class="confirm-title">{{ i18n.selected_item }}</div>
        <div class="confirm-price">
          {{ rentalProductType == "2" ? i18nHome.fast_charge_powerbank : i18nHome.standard_powerbank }} × 1
        </div>
        <!-- <div class="confirm-title">{{ i18n.pay_label }}</div>
        <div class="confirm-price">
          {{ currency
          }}{{ payType === "YJ" ? cabinet.yajin : $moneyFormat(price) }}
        </div> -->
      </div>
      <div class="confirm-payment-label">
        <span>{{ i18n.pay_type }}</span>
      </div>
      <div class="confirm-payment">
        <!-- <div class="confirm-payment-item" @click="payMode='paypal'">
            <div class="confirm-payment-item-info">
              <img src="../../assets/imgs/icon_paypal.png" />
              <div class="content">
                <div class="title">Paypal</div>
              </div>
            </div>
            <div class="confirm-payment-item-checked">
              <img v-if="payMode==='paypal'" src="../../assets/imgs/checkbox_selected.png" />
            </div>
          </div> -->
        <template v-for="item in payModeList">
          <div
            :key="item.pId"
            v-if="
              item.phone === 'all' ||
                item.phone === system ||
                item.phone === browser ||
                (item.phone === 'phone' && system !== '')
            "
          >
            <div
              class="confirm-payment-item"
              :class="{
                bordermaincolor:
                  payMode === item.pPaymentType && item.pId === pId
              }"
              @click="onPayMode(item)"
            >
              <div class="confirm-payment-item-info">
                <img
                  v-if="
                    item.pPaymentType === 'GOOGLE_PAY' ||
                      item.pPaymentType === 'STRIPE_GOOGLE'
                  "
                  :src="require('../../assets/imgs/icon_googlepay.png')"
                />
                <img
                  v-else-if="
                    item.pPaymentType === 'APPLE_PAY' ||
                      item.pPaymentType === 'STRIPE_APPLE'
                  "
                  :src="require('../../assets/imgs/icon_applepay.png')"
                />
                <img
                  v-else-if="item.pPaymentType === 'PAYPAL'"
                  :src="require('../../assets/imgs/icon_paypal.png')"
                />
                <img
                  v-else-if="item.pPaymentType === 'PayPay'"
                  :src="require('../../assets/imgs/icon_paypay.png')"
                />
                <img
                  v-else
                  :src="require('../../assets/imgs/icon_creditcard.png')"
                />
                <div class="content">
                  <div class="title">{{ item.label }}</div>
                </div>
              </div>
              <div class="confirm-payment-item-checked">
                <img
                  v-if="payMode === item.pPaymentType && item.pId === pId"
                  src="../../assets/imgs/checkbox_selected.png"
                />
              </div>
            </div>
            <!-- <div v-if="item.paymentConfig" class="confirm-payment-item-operate">
              <span
                class="confirm-payment-item-operate-text"
                @click="deletePayCard(item)"
                >{{ i18n.deletecard }}</span
              >
            </div> -->
          </div>
        </template>
      </div>
      <div class="confirm-deposit-tips">
        <div>{{ depositIncludes }}</div>
        <div>{{ i18nHome.deposit_return }}</div>
      </div>
      <div class="confirm-btns">
        <div class="btn" @click="onPay" :disabled="disabled">
          {{ i18n.submit }}
        </div>
      </div>
      <!-- <div class="home-borrow-tips">{{ i18nHome.borrow_tips }}</div>
      <div class="home-pay-icon">
        <img src="@/assets/imgs/icon_pay.png" alt="">
      </div>
      <div class="home-info-card">
        <div class="home-info-list">
          <div class="home-info-row">
            <img src="@/assets/imgs/icon_address3.png" alt="">
            <span>{{ i18nHome.company_address }}</span>
          </div>
          <div class="home-info-row">
            <img src="@/assets/imgs/icon_phone2.png" alt="">
            <span>{{ i18nHome.company_phone }}</span>
          </div>
        </div>
        <div class="home-info-list">
          <div class="home-info-row">
            <img src="@/assets/imgs/icon_email.png" alt="">
            <span>{{ i18nHome.company_email }}</span>
          </div>
          <div class="home-info-row">
            <img src="@/assets/imgs/icon_id.png" alt="">
            <span>{{ i18nHome.company_id }}</span>
          </div>
          <div class="home-info-row">
            <img src="@/assets/imgs/icon_tax.png" alt="">
            <span>{{ i18nHome.company_vat }}</span>
          </div>
        </div>
      </div> -->
      <popup-warp v-model="isCreditcard">
        <div>
          <div class="creditcard-input">
            <div id="credit-card-element"></div>
          </div>
          <div class="btn creditcard-btn" @click="onStripeSetup">
            {{ i18n.submit }}
          </div>
        </div>
      </popup-warp>
      <popup-warp v-model="isMonriCard">
        <form action="" method="post" id="payment-form">
          <div class="form-row">
            <div
              for="card-element"
              class="form-title"
              style="padding-top: 12px;"
            >
              -Credit or debit card-
            </div>
            <div id="card-element">
              <!-- A Monri Component will be inserted here. -->
            </div>
            <div>
              <div class="form-title">
                -Billing Information-
              </div>
              <div class="monri-input-row">
                <div class="monri-input-label">E-MAIL</div>
                <div class="monri-input-flex">
                  <input
                    type="email"
                    v-model="monriBilling.email"
                    class="monri-input"
                    placeholder="email"
                  />
                </div>
              </div>
              <div class="monri-input-row">
                <div class="monri-input-label">PHONE</div>
                <div class="monri-input-flex">
                  <input
                    type="tel"
                    v-model="monriBilling.phone"
                    class="monri-input"
                    placeholder="phone"
                    aria-placeholder=""
                  />
                </div>
              </div>
              <div class="monri-input-flex">
                <div class="monri-input-row" style="padding-right: 5Px;">
                  <div class="monri-input-label">CITY</div>
                  <div class="monri-input-flex">
                    <input
                      type="text"
                      v-model="monriBilling.city"
                      class="monri-input"
                      placeholder="city"
                    />
                  </div>
                </div>
                <div class="monri-input-row" style="padding-left: 5Px;">
                  <div class="monri-input-label">ZIP</div>
                  <div class="monri-input-flex">
                    <input
                      type="text"
                      v-model="monriBilling.zip"
                      class="monri-input"
                      placeholder="zip code"
                    />
                  </div>
                </div>
              </div>
              <div class="monri-input-row">
                <div class="monri-input-label">ADDRESS</div>
                <div class="monri-input-flex">
                  <input
                    type="tel"
                    v-model="monriBilling.address"
                    class="monri-input"
                    placeholder="address"
                    aria-placeholder=""
                  />
                </div>
              </div>
            </div>
            <!-- Used to display Component errors. -->
            <div class="monri-errors" id="card-errors" role="alert"></div>
          </div>
          <div class="confirm-btns">
            <button class="btn" style="width: -webkit-fill-available;">
              Submit Payment
            </button>
          </div>
        </form>
      </popup-warp>
    </div>
  </page>
</template>

<script>
import { mapState } from "vuex";
import { getToken } from "../../utils/stripe_pay.js";
import {
  STRIPE_PREPAY_SPTOKEN,
  STRIPE_PAYORDER_SPTOKEN,
  PAYPAL_PREAUTH,
  STRIPE_PREAUTH_OF_CONFIRM,
  STRIPE_PREAUTH_AUTO_CONFIRM,
  PAYMODE,
  STRIPE_PAYORDER,
  STRIPE_RECHARGE_WALLET,
  SAVED_CARD_RENT,
  STRIPE_SAVE_CARD,
  STRIPE_SAVE_CARD_CONFIRM,
  REMOVE_CARD,
  USER_CARD,
  PAYPAL_CARD_PREAUTH,
  SUMUP_PAYORDER,
  SUMUP_SAVECARDOFINTENT,
  PAY_RECHARGE,
  PAY_CONFIRM
} from "../../apis/payment";
import { ORDER_SAVEDCARDTORENT } from "../../apis/cabinet.js";
import stripeMixin from "../../mixins/stripe";
import { PopupWarp } from "../../components/popup";
import monriMixin from "../../mixins/monri";
import { USER_MORE } from "../../apis/user.js";

export default {
  mixins: [stripeMixin, monriMixin],
  components: {
    PopupWarp
  },
  computed: {
    ...mapState([
      "system",
      "browser",
      "cabinet",
      "user",
      "wallet",
      "agentId",
      "paypayInfo"
    ]),
    i18n() {
      return this.$t("confirm");
    },
    i18nHome() {
      return this.$t("home");
    },
    i18nMsg() {
      return this.$t("msg");
    },
    currency() {
      if (this.cabinet) {
        return this.cabinet.currencyName;
      } else {
        return this.user.pcurrencyName;
      }
    },
    qrcode() {
      return (this.cabinet && this.cabinet.qrcode) || "";
    },
    depositIncludes() {
      return `${this.i18nHome.deposit_includes}`.format(this.cabinet);
    }
  },
  watch: {
    payMode(val, oldVal) {
      console.log("payMode", val);
      // if (
      //   val === "APPLE_PAY" ||
      //   val === "STRIPE_APPLE" ||
      //   val === "STRIPE_GOOGLE" ||
      //   val === "GOOGLE_PAY"
      // ) {
      //   if (!this.stripePayRequest) {
      //     this.disabled = true;
      //     this.$loading(true);
      //     this.getStripeToken();
      //   } else {
      //     this.disabled = false;
      //   }
      // } else {
      //   this.disabled = false;
      // }
    },
    stripePayRequest(val, oldVal) {
      this.disabled = !val;
    }
  },
  data() {
    return {
      price: 0,
      payType: "YJ",
      formId: "",
      cabinetID: "",
      yaJinType: null,
      pdailiId: "",
      payMode: "STRIPE_CARD",
      pId: "", // 代理或平台支付配置id
      currencySymbol: "$",
      country: "US", // 国家
      currencyname: "usd", // 货币类型
      publicKey: "", // 支付通道的公钥
      paymentConfig: {},
      disabled: false,
      stripePayRequest: null,
      isCreditcard: false,
      cardStyle: {
        base: {
          color: "#32325d",
          fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
          fontSmoothing: "antialiased",
          fontSize: "16px",
          "::placeholder": {
            color: "#aab7c4"
          }
        },
        invalid: {
          color: "#fa755a",
          iconColor: "#fa755a"
        }
      },
      creditcard: null,
      clientSecret: null,
      payModeList: [],
      orderId: "",
      phone: "",
      isMonriCard: false,
      monriBilling: {
        address: "",
        fullName: "",
        city: "",
        zip: "",
        phone: "",
        country: "BA",
        email: "",
        orderInfo: "preAuth"
      },
      rentalProductType: ''
    };
  },
  methods: {
    // 支付方式选中
    onPayMode(v) {
      console.log("支付方式===", v);
      this.pId = v.pId;
      this.payMode = v.pPaymentType;
      this.currencySymbol = v.currencySymbol;
      this.currencyname = v.configDetails.currency;
      this.publicKey = v.publicKey;
      this.country = v.configDetails.accountCountry;
      this.paymentConfig = v.paymentConfig;
      if (
        v.publicKey &&
        v.pPaymentType !== "M-PESA" &&
        v.pPaymentType !== "MIDTRANS_CARD" &&
        v.pPaymentType !== "MIDTRANS_GOPAY"
      ) {
        this.loadStripeScript(v.publicKey);
      }
    },
    // 删除支付卡
    deletePayCard(v) {
      this.$post(
        `${REMOVE_CARD}/${v.pId}`,
        {},
        resp => {
          this.$loading(false);
          console.log(resp);
          this.$toast(this.i18nMsg.success);
          this.getPayMode();
        },
        error => {
          this.$loading(false);
          console.log(error);
          this.$confirm({
            title: this.i18nMsg.title,
            content: this.i18nMsg.error,
            confirmText: this.i18nMsg.confirm,
            showCancel: false
          });
        }
      );
    },
    onPay() {
      console.log(`payMode-${this.payMode}`);
      if (this.payMode === "PAYPAL") {
        this.onPaypal();
      } else if (this.payMode === "PAYPAL_CARD") {
        this.onPaypalCard();
      } else if (
        this.payMode === "APPLE_PAY" ||
        this.payMode === "GOOGLE_PAY" ||
        this.payMode === "STRIPE_APPLE" ||
        this.payMode === "STRIPE_GOOGLE"
      ) {
        // this.stripePayRequest.show()
        this.onCreditcard(this.publicKey);
      } else if (
        this.payMode === "STRIPE_CARD" ||
        this.payMode === "STRIPE_KLARNA"
      ) {
        this.onCreditcard(this.publicKey);
      } else if (this.payMode === "SumUpOnlinePayment") {
        this.onSumUp();
      } else if (this.payMode === "Monri_WebPay") {
        this.onMonri();
      } else if (this.payMode === "PayPay") {
        this.onPayPay();
      } else {
        this.$loading(true);
        setTimeout(() => {
          this.$loading(false);
          this.$router.replace("/result");
        }, 3000);
      }
    },
    checkOrder(tradeNo, payType, query) {
      if (payType === "CZ") {
        this.$confirm({
          title: this.i18nMsg.title,
          content: this.i18nMsg.success_payment,
          confirmText: this.i18nMsg.confirm,
          showCancel: false
        }).then(() => {
          this.$router.replace("/mine");
        });
      } else {
        if (payType === "FK") {
          this.$router.replace(
            `/result?tradeNo=${tradeNo}&payMode=stripe&payType=FK`
          );
          return;
        }
        this.$router.replace(`/result?tradeNo=${tradeNo}&payMode=stripe`);
      }
    },
    getStripeToken() {
      getToken(this.price, this.country, this.currencyname, this.onStripe)
        .then(data => {
          console.log("stripe getToken", data);
          this.stripePayRequest = data;
          this.$loading(false);
        })
        .catch(error => {
          this.stripePayRequest = null;
          console.log("stripe getTokenerr", error);
          this.$loading(false);
          this.$confirm({
            title: this.i18n.msg_fail_title,
            content: this.i18n.msg_fail_support,
            showCancel: false,
            confirmText: this.i18n.msg_fail_confirm
          });
        });
    },
    // apple和Google支付时调用
    onStripe(token, ev) {
      let url = "";
      let datas = {};
      if (this.cabinet && this.payType === "YJ") {
        url = STRIPE_PREPAY_SPTOKEN;
        datas = {
          qrcode: this.qrcode,
          stripeToken: token, // stripe官方支付的一次性token
          paymentId: this.pId // 代理或平台支付配置id
        };
      } else if (this.price > 0 && this.payType === "FK") {
        url = STRIPE_PAYORDER_SPTOKEN;
        datas = {
          outTradeNo: this.orderId,
          couponNo: null,
          stripeToken: token,
          paymentId: this.pId
        };
      } else {
        this.$confirm({
          title: this.i18nMsg.title,
          content: this.i18nMsg.error,
          confirmText: this.i18nMsg.confirm,
          showCancel: false
        }).then(() => {
          this.$router.push("/");
        });
      }
      this.$post(
        url,
        datas,
        resp => {
          if (ev && ev.complete) {
            ev.complete("success");
          }
          this.$loading(false);
          console.log(resp);
          if (this.payType === "CZ") {
            this.$confirm({
              title: this.i18nMsg.title,
              content: this.i18nMsg.success_payment,
              confirmText: this.i18nMsg.confirm,
              showCancel: false
            }).then(() => {
              this.$router.replace("/mine");
            });
          } else {
            this.$toast(this.i18nMsg.success_payment);
            if (this.payType === "FK") {
              this.$router.replace(
                `/result?tradeNo=${resp.data.orderId}&payMode=stripe&payType=FK`
              );
              return;
            }
            this.$router.replace(
              `/result?tradeNo=${resp.data.orderId}&payMode=stripe`
            );
          }
        },
        error => {
          if (ev && ev.complete) {
            ev.complete("fail");
          }
          this.$loading(false);
          console.log(error);
          this.$confirm({
            title: this.i18nMsg.title,
            content: this.i18nMsg.error,
            confirmText: this.i18nMsg.confirm,
            showCancel: false
          });
        }
      );
    },
    onConfirmSaveCard(pid, id) {
      this.$loading(true);
      this.$post(
        STRIPE_SAVE_CARD_CONFIRM,
        {
          paymentId: pid,
          paymentMethod: id
        },
        resp => {
          this.$loading(false);
          console.log("saveCardConfirm====", resp);
          //   this.getCardList()
          this.saveToRent();
        },
        error => {
          this.$loading(false);
          this.$confirm({
            title: this.i18nMsg.msg_fail_title,
            content: error,
            confirmText: this.i18nMsg.retry,
            cancelText: this.i18nMsg.cancel
          }).then(() => {
            this.onConfirmSaveCard(pid, id);
          });
          console.log(error);
        }
      );
    },
    saveToRent() {
      this.$loading(true);
      this.$get(
        `${SAVED_CARD_RENT}`,
        {
          qrcode: this.cabinet.cabinetID || this.$route.query.qrcode
        },
        resp => {
          this.$loading(false);
          console.log(resp);
          if (resp.data && resp.data.out_trade_no) {
            this.checkOrder(resp.data.out_trade_no, this.payType);
          }
        },
        error => {
          this.$loading(false);
          console.log(error);
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }
      );
    },
    // 获取用户支付卡信息
    async getUserPayCard() {
      this.$loading(true);
      const { data = [] } = await this.$Request("get", USER_CARD, {
        qrcode: this.qrcode,
        orderId: this.orderId,
        agentld: this.agentId
      });
      let cardList = [];
      if (data && data.length) {
        cardList = data.map(item => {
          return {
            phone: "all",
            label: item.pCardnumber,
            ...item.paymentConfig,
            ...item,
            pPaymentType:
              item.paymentWay === "PAYPAL" ? "PAYPAL_CARD" : item.paymentWay
          };
        });
        this.cardList = cardList;
      }
      this.$loading(false);
      return cardList;
    },
    onPaypal() {
      this.$loading(true);
      let url = PAYPAL_PREAUTH + `/${this.qrcode}`;
      this.$post(
        url,
        {
          paymentId: this.pId
          // returnUrl: `${window.location.origin}/#/result?paymentId=${this.pId}`
        },
        resp => {
          this.$loading(false);
          if (resp.data) {
            this.$loading(true);
            this.$store.commit("paypalTradeNo", resp.data.tradeNo);
            this.$store.commit("paymentId", this.pId);
            window.location.href = resp.data.approve;
          }
        },
        error => {
          this.$loading(false);
          this.$confirm({
            title: this.i18n.msg_fail_title,
            content: this.i18n.msg_fail_order,
            confirmText: this.i18n.msg_fail_retry,
            cancelText: this.i18n.msg_fail_cancel
          }).then(() => {
            this.onPaypal();
          });
          console.log(error);
        }
      );
    },
    onPaypalCard() {
      this.$loading(true);
      let url = PAYPAL_CARD_PREAUTH + `/${this.qrcode}?cardId=${this.pId}`;
      this.$post(
        url,
        {},
        resp => {
          this.$loading(false);
          if (resp.data) {
            this.$router.replace(
              `/result?outTradeNo=${resp.data.outTradeNo}&payMode=stripe&payType=${this.payType}`
            );
          }
        },
        error => {
          this.$loading(false);
          this.$confirm({
            title: this.i18n.msg_fail_title,
            content: this.i18n.msg_fail_order,
            confirmText: this.i18n.msg_fail_retry,
            cancelText: this.i18n.msg_fail_cancel
          }).then(() => {
            this.onPaypalCard();
          });
          console.log(error);
        }
      );
    },
    async cardToRent() {
      let url = `${SAVED_CARD_RENT}/${this.cabinet.cabinetID}`;
      this.$loading(true);
      const param = {
        cardId: this.pId,
        paymentId: this.paymentConfig.pId,
        amount: this.price
      };
      // 多产品
      if (this.Query.rentalProductType) {
        param.rentalProductType = this.Query.rentalProductType;
      }
      const result = await this.$Request("post", url, param);
      this.$loading(false);
      if (result.data && result.data.outTradeNo) {
        this.checkOrder(result.data.outTradeNo, this.payType);
      } else {
        this.$confirm({
          title: this.i18n.msg_fail_title,
          content: this.i18n.msg_fail_order,
          confirmText: this.i18n.msg_fail_retry,
          cancelText: this.i18n.msg_fail_cancel
        }).then(() => {
          this.cardToRent();
        });
      }
    },
    onCreditcard(publicKey) {
      // console.log('publicKey', publicKey)
      const { paymentWay } = this.$route.query;
      let paymentId = this.pId;
      if (this.paymentConfig && this.paymentConfig.pId) {
        paymentId = this.paymentConfig.pId;
      }

      if (paymentWay === "PAYMENT_CARD") {
        return this.saveCard();
      }
      let url = "";
      let datas = {};
      if (this.cabinet && this.payType === "YJ") {
        url = `${STRIPE_PREAUTH_OF_CONFIRM}/${this.cabinet.cabinetID}`;
        datas = {
          paymentId: paymentId,
          amount: this.price
        };
        if (this.paymentConfig) {
          return this.cardToRent(this.paymentConfig);
        }
      } else if (this.price > 0 && this.payType === "FK") {
        url = STRIPE_PAYORDER;
        datas = {
          outTradeNo: this.orderId,
          couponNo: null,
          paymentId: paymentId
        };
        if (this.paymentConfig) {
          datas.cardId = this.pId;
        }
      } else {
        url = STRIPE_RECHARGE_WALLET;
        datas = {
          amount: this.price,
          paymentId: paymentId
        };
      }
      // 多产品
      if (this.Query.rentalProductType) {
        datas.rentalProductType = this.Query.rentalProductType;
      }
      this.$loading(true);
      this.$post(
        url,
        datas,
        resp => {
          this.$loading(false);
          console.log(url, resp);
          if (resp.data) {
            this.createStripePayment(resp.data);
            // if (datas.cardId && this.payType === "FK") {
            //   this.checkOrder(datas.outTradeNo, this.payType);
            //   return;
            // }
            // if (window.stripe) {
            //   this.clientSecret = resp.data;
            //   const layout = {
            //     layout: "tabs"
            //   };
            //   const options = {
            //     clientSecret: resp.data.clientSecret,
            //     appearance: {
            //       theme: "stripe"
            //     }
            //   };
            //   this.creditcard = window.stripe.elements(options);
            //   const paymentElement = this.creditcard.create("payment", layout);
            //   this.isCreditcard = true;
            //   paymentElement.mount("#credit-card-element");
            // } else {
            //   this.$toast("loading...");
            // }
          }
        },
        error => {
          this.$loading(false);
          this.$confirm({
            title: this.i18n.msg_fail_title,
            content: this.i18n.msg_fail_order,
            confirmText: this.i18n.msg_fail_retry,
            cancelText: this.i18n.msg_fail_cancel
          }).then(() => {
            this.onCreditcard(publicKey);
          });
          console.log(error);
        }
      );
    },

    saveCard() {
      const { paymentWay, paymentId } = this.$route.query;
      console.log("this.payMode", this.payMode);
      if (!this.user) {
        this.$toast(this.i18nMsg.unlogin);
        return;
      }
      if (!this.payMode || !this.pId) {
        this.$toast(this.i18nMsg.nopaymode);
        return;
      }
      let url = `${STRIPE_SAVE_CARD}?paymentId=${paymentId || this.pId}`;
      this.$loading(true);
      this.$post(
        url,
        {},
        resp => {
          this.$loading(false);
          this.creditOrder = resp.data;
          if (paymentWay === "PAYMENT_CARD") {
            this.onLoadElement();
          }
          // this.onCreditcard(this.publicKey)

          console.log("saveCard====", resp);
        },
        error => {
          this.$loading(false);
          this.$confirm({
            title: this.i18nMsg.msg_fail_title,
            content: error,
            confirmText: this.i18nMsg.retry,
            cancelText: this.i18nMsg.cancel
          }).then(() => {
            this.saveCard();
          });
          console.warn(error);
        }
      );
    },
    onLoadElement() {
      const options = {
        clientSecret: this.creditOrder.clientSecret,
        appearance: {
          theme: "stripe"
        }
      };
      if (window.stripe) {
        // this.loadStripeScript(this.payMode.publicKey)
        this.creditcard = window.stripe.elements(options);
        const paymentElement = this.creditcard.create("payment");
        this.isCreditcard = true;
        // this.payListShow = false
        paymentElement.mount("#credit-card-element");
      } else {
        this.$toast("loading...");
        this.loadStripeScript();
        setTimeout(() => {
          this.onLoadElement();
        }, 500);
      }
    },
    onStripeSetup() {
      const vm = this;
      vm.$loading(true);
      const { paymentWay } = this.$route.query;
      // 失败事件回调
      const failCall = result => {
        console.log(result);
        vm.$loading(false);
        if (result.error) {
          vm.$toast(result.error.message);
        }
      };
      if (paymentWay === "PAYMENT_CARD") {
        let url = `${window.location.origin}#/confirm?qrcode=${this.qrcode}&paymentId=${this.pId}&pmid=${this.creditOrder.paymentId}`;
        window.stripe
          .confirmSetup({
            elements: vm.creditcard,
            confirmParams: {
              // Make sure to change this to your payment completion page
              return_url: url
            }
          })
          .then(result => failCall(result));
      } else {
        window.stripe
          .confirmPayment({
            elements: vm.creditcard,
            confirmParams: {
              // Make sure to change this to your payment completion page
              return_url: `${window.location.href}&paymentId=${this.pId}`
            }
          })
          .then(result => failCall(result));
      }
    },
    confirmSetup(id) {
      const { paymentWay } = this.$route.query;
      this.$loading(true);
      this.$get(
        // `${STRIPE_PREAUTH_AUTO_CONFIRM}`,
        `${STRIPE_PREAUTH_AUTO_CONFIRM}?tradeNo=${id}`,
        {},
        resp => {
          this.$loading(false);
          this.isCreditcard = false;
          if (paymentWay === "PAYMENT_SAVED_PROPAY") {
            this.saveCard();
          }
          let jumpUrl = `/result?tradeNo=${resp.data.orderId}&payMode=stripe`;
          if (this.payType !== "YJ") {
            jumpUrl = `/result?tradeNo=${resp.data.orderId}&payMode=stripe&payType=${this.payType}`;
          }
          this.$router.replace(jumpUrl);
          console.log(resp);
        },
        error => {
          this.$loading(false);
          console.log(error);
        }
      );
    },
    getPayMode() {
      console.log("hahah", this.cabinet, this.wallet);
      this.$loading(true);
      let agentId = "";
      if (this.payType === "CZ") {
        agentId = this.wallet
          ? this.wallet.pDailiId
          : this.cabinet.userWallet.pDailiId;
      }
      this.$get(
        `${PAYMODE}?id=${this.qrcode}&pOrderId=${this.orderId}`,
        {},
        async resp => {
          this.$loading(false);
          console.log(resp);
          if (resp.data) {
            let list = resp.data;
            list.map((v, i, arr) => {
              if (v.pPaymentType === "STRIPE_CARD") {
                v.label = "Credit Card";
                v.phone = "all";
              } else if (
                v.pPaymentType === "APPLE_PAY" ||
                v.pPaymentType === "STRIPE_APPLE"
              ) {
                v.label = "Apple Pay";
                v.phone = "ios";
              } else if (
                v.pPaymentType === "GOOGLE_PAY" ||
                v.pPaymentType === "STRIPE_GOOGLE"
              ) {
                v.label = "Google Pay";
                v.phone = "android";
              } else if (v.pPaymentType === "PAYPAL") {
                v.label = "Paypal";
                v.phone = "all";
              } else if (v.pPaymentType === "STRIPE_KLARNA") {
                v.label = "Klarna";
                v.phone = "all";
              } else if (v.pPaymentType === "SumUpOnlinePayment") {
                //   v.label = "SumUp Pay"
                v.label = "Credit Card";
                v.phone = "all";
              } else if (v.pPaymentType === "Monri_WebPay") {
                v.label = "Credit Card";
                v.phone = "all";
              } else if (v.pPaymentType === "PayPay") {
                v.label = "PayPay";
                v.phone = "all";
              }
              // list.push(v)
            });
            list = list.filter(v => !!v.label);
            const plist = await this.getUserPayCard();
            list = [...plist, ...list];

            this.payModeList = list;
            let isStripe = false;
            let isMonri = false;

            if (list.length > 0) {
              let item = list.filter(v => {
                if (v.pPaymentType.includes("STRIPE")) {
                  isStripe = true;
                  this.publicKey = v.publicKey;
                }
                if (v.pPaymentType === "Monri_WebPay") {
                  isMonri = true;
                }
                if (this.browser === "wechat") {
                  return v.pPaymentType === "WeChat_MP";
                } else {
                  return v.pPaymentType === "STRIPE_CARD";
                }
              });
              this.payMode = list[0].pPaymentType;
              this.currencySymbol = list[0].currencySymbol; // 货币符号
              this.currencyname = list[0].configDetails.currency; // 货币类型
              // this.publicKey = list[0].publicKey || ""
              this.paymentConfig = list[0].paymentConfig;
              this.pId = list[0].pId;
              this.country = list[0].configDetails.accountCountry;
              console.log(this.publicKey, this.payMode);
              if (isStripe) {
                this.loadStripeScript(this.publicKey);
              }
              if (isMonri) {
                this.loadMonriScript();
              }
            }
            console.log("list======", list);
          }
        },
        error => {
          this.$loading(false);
          this.$confirm({
            title: this.i18n.msg_fail_title,
            content: this.i18n.msg_fail_order,
            confirmText: this.i18n.msg_fail_retry,
            cancelText: this.i18n.msg_fail_cancel
          }).then(() => {
            this.getPayMode();
          });
          console.log(error);
        }
      );
    },
    // sumUp 支付
    async onSumUp() {
      this.$loading(true);
      let datas = {};
      if (this.paymentConfig && this.paymentConfig.pId) {
        let method = "";
        let url = "";
        if (this.payType === "YJ") {
          method = "get";
          url = ORDER_SAVEDCARDTORENT;
          datas = {
            qrcode: this.qrcode || this.$route.query.cabinetID
          };
        } else {
          method = "post";
          url = SUMUP_PAYORDER;
          datas = {
            paymentId: this.paymentConfig.pId,
            outTradeNo: this.orderId,
            userCardId: this.pId
          };
        }
        this.SumUpRequest(method, url, datas)
          .then(resp => {
            this.$loading(false);
            const res = resp.data;
            this.$router.replace(
              `/result?tradeNo=${res.out_trade_no}&payMode=${this.payMode}&payType=${this.payType}`
            );
          })
          .catch(error => {
            this.$loading(false);
            console.log(error);
            this.$toast(error);
          });
      } else {
        return this.saveCardSumUp();
      }
    },
    // 获取checkoutId跳转SumUp获取保存支付卡信息
    saveCardSumUp() {
      // 支付完成回调 codeUrl
      const redirectUri = `#/result?paymentId=${this.pId}&payMode=SumUpOnlinePayment&payType=${this.payType}`;
      const datas = {
        paymentId: this.pId,
        amount: this.price,
        redirectUri: redirectUri,
        qrcode: this.qrcode || this.$route.query.cabinetID
      };
      this.SumUpRequest("post", SUMUP_SAVECARDOFINTENT, datas)
        .then(resp => {
          this.$loading(false);
          if (resp.data && resp.data.checkoutId) {
            // 跳转到支付拉起页面
            const _payUri = `${process.env.VUE_APP_DoMain}/sumup.html`;
            window.location.href = `${_payUri}?tradeNo=${resp.data.checkoutId}&redirectUri=/`;
          }
        })
        .catch(error => {
          this.$loading(false);
          console.log(error);
          this.$toast(error);
        });
    },
    //  接口请求
    SumUpRequest(method, url, query = {}) {
      let requestRetryCount = 3;
      return new Promise((resolve, reject) => {
        let _headers = {
          headers: { "Content-Type": "application/json;charset=UTF-8" }
        };
        if (method.toLocaleUpperCase() === "POST") {
          const confirmRequest = () => {
            this.$post(
              url,
              query,
              resp => resolve(resp),
              error => {
                if (error === "正在请求中" || error === "Processing") {
                  if (requestRetryCount > 0) {
                    requestRetryCount--;
                    setTimeout(confirmRequest, 1000);
                  }
                }
                reject(error);
              },
              _headers
            );
          };
          confirmRequest();
        } else {
          const confirmRequest = () => {
            this.$get(
              url,
              query,
              resp => resolve(resp),
              error => {
                if (error === "正在请求中" || error === "Processing") {
                  if (requestRetryCount > 0) {
                    requestRetryCount--;
                    setTimeout(confirmRequest, 1000);
                  }
                }
                reject(error);
              }
            );
          };
          confirmRequest();
        }
      });
    },
    onMonri() {
      this.$loading(true);
      let _this = this;
      let url = PAY_RECHARGE;
      let datas = {};
      _this.monriBilling.fullName = _this.user.p_name || _this.user.p_openID;
      _this.monriBilling.country = "BA";
      if (this.payType === "YJ") {
        datas = {
          paymentId: this.pId,
          rechargeType: "preAuth",
          amount: this.price,
          qrCode: this.qrcode || this.$route.query.cabinetID,
          rentNow: true
        };
        _this.monriBilling.orderInfo = "preAuth";
      } else {
        datas = {
          outTradeNo: this.orderId,
          paymentId: this.pId,
          rechargeType: "pay"
        };
        _this.monriBilling.orderInfo = "pay";
      }
      this.$post(
        url,
        datas,
        resp => {
          this.$loading(false);
          console.log(resp);
          if (resp.data && resp.data.paymentInfo) {
            this.loadMonriScript(() => {
              let monri = Monri(resp.data.paymentInfo.authenticityToken);
              let components = monri.components({
                clientSecret: resp.data.paymentInfo.client_secret
              });
              let card = components.create("card");

              card.mount("card-element");

              var form = document.getElementById("payment-form");
              form.addEventListener("submit", function(event) {
                _this.$loading(true);
                event.preventDefault();
                _this.setUserMore();
                monri
                  .confirmPayment(card, _this.monriBilling)
                  .then(function(result) {
                    _this.$loading(false);
                    if (result.error) {
                      // Inform the customer that there was an error.
                      var errorElement = document.getElementById("card-errors");
                      errorElement.textContent = result.error.message;
                    } else {
                      _this.handlePaymentResult(
                        result.result,
                        resp.data.outTradeNo
                      );
                    }
                  });
              });
              this.$nextTick(() => {
                _this.isMonriCard = true;
                // card.mount('card-element');
              });
            });
          }
        },
        error => {
          this.$loading(false);
          console.log(error);
          this.$toast(error);
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }
      );
    },
    handlePaymentResult(paymentResult, orderId) {
      // Handle PaymentResult
      if (paymentResult.status === "approved") {
        let jumpUrl = `/result?tradeNo=${orderId}&payMode=monri`;
        if (this.payType !== "YJ") {
          jumpUrl = `/result?tradeNo=${orderId}&payMode=monri&payType=${this.payType}`;
        }
        this.$router.replace(jumpUrl);
      } else {
        console.log("pay err");
      }
    },
    getUserMore() {
      this.$get(
        USER_MORE,
        {
          keys: "monriBilling"
        },
        resp => {
          if (resp.data && resp.data.monriBilling) {
            try {
              let temp = JSON.parse(resp.data.monriBilling);
              this.monriBilling = Object.assign({}, this.monriBilling, temp);
            } catch (error) {}
          }
        }
      );
    },
    setUserMore() {
      this.$post(
        USER_MORE,
        {
          monriBilling: JSON.stringify(this.monriBilling)
        },
        resp => {},
        error => {
          console.log(error);
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }
      );
    },
    onPayPay(userAuthorizationId) {
      this.$loading(true);
      let _this = this;
      let url = PAY_RECHARGE;
      let datas = {};
      if (userAuthorizationId) {
        datas = this.paypayInfo;
        datas.userAuthorizationId = userAuthorizationId;
        if (this.Query && this.Query.paymentId) {
          datas.paymentId = this.Query.paymentId;
        }
      } else if (this.payType === "YJ") {
        datas = {
          paymentId: this.pId,
          rechargeType: "preAuth",
          amount: this.price,
          qrCode: this.qrcode || this.$route.query.cabinetID,
          rentNow: true,
          returnUrl: `${process.env.VUE_APP_DOMAIN}/#/confirm?payType=${this.payType}`
        };
      } else {
        datas = {
          outTradeNo: this.orderId,
          paymentId: this.pId,
          rechargeType: "pay",
          returnUrl: `${process.env.VUE_APP_DOMAIN}/#/confirm?payType=${this.payType}`
        };
      }
      // 多产品
      if (this.Query.rentalProductType) {
        datas.rentalProductType = this.Query.rentalProductType;
      }
      this.$post(
        url,
        datas,
        resp => {
          this.$loading(false);
          console.log(resp);
          if (resp.data && resp.data.approvalUrl) {
            this.$store.commit("paypayInfo", datas);
            setTimeout(() => {
              window.location.href = resp.data.approvalUrl;
            }, 300);
          } else if (userAuthorizationId && resp.data.outTradeNo) {
            this.confirmPayPay(resp.data.outTradeNo);
          }
        },
        error => {
          this.$loading(false);
          console.log(error);
          this.$toast(error);
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }
      );
    },
    confirmPayPay(outTradeNo) {
      this.$loading(true);
      this.$get(
        `${PAY_CONFIRM}?outTradeNo=${outTradeNo}`,
        {},
        resp => {
          this.$loading(false);
          console.log(resp);
          this.$store.commit("paypayInfo", {});
          let orderId = resp.data["outTradeNo"] || resp.data["orderId"];
          let jumpUrl = `/result?tradeNo=${orderId}&payMode=paypay`;
          if (this.payType !== "YJ") {
            jumpUrl = `/result?tradeNo=${orderId}&payMode=paypay&payType=${this.payType}`;
          }
          this.$router.replace(jumpUrl);
        },
        error => {
          this.$loading(false);
          console.log(error);
          this.$toast(error);
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }
      );
    }
  },
  created() {
    this.Query = this.$route.query;
    let { paymentId, pmid } = this.$route.query;
    let price = this.$route.query.price;
    let formId = this.$route.query.formId;
    this.price = price ? Number(price) : 0;
    this.orderId = this.$route.query.outTradeNo || "";
    this.formId = formId;
    this.payType = this.$route.query.payType;
    this.cabinetID = this.$route.query.cabinetID;
    this.yaJinType = this.$route.query.yaJinType;
    this.rentalProductType = this.$route.query.rentalProductType;
    const payId = new URLSearchParams(window.location.search).get(
      "payment_intent"
    );
    console.log(`query-payId:${payId}-paymentId:${paymentId}-pmid:${pmid}`);
    if (paymentId && pmid) {
      this.onConfirmSaveCard(paymentId, pmid);
    } else if (payId) {
      this.confirmSetup(payId);
    }
    let userAuthorizationId = this.$route.query.responseToken;
    let payMode = this.$route.query.payMode;
    if (userAuthorizationId) {
      this.onPayPay(userAuthorizationId);
    } else if (payMode === 'PayPay' && this.orderId) {
      this.confirmPayPay(this.orderId);
    } else {
      this.getPayMode();
      this.getUserMore();
    }
    console.log(this);
  }
};
</script>

<style lang="less" scoped>
@mainColor: #000;
.noClick {
  opacity: 0.5;
  pointer-events: none;
  /* 禁止鼠标点击 */
}

.confirm-warp {
  min-height: 92vh;
  overflow-y: scroll;
  background: #fff;
  .form-row {
    padding: 0 32px;
  }
  .form-title {
    width: 100%;
    font-size: 28px;
    padding: 0 0 10px;
    text-align: center;
  }
  .monri-input-row {
    flex: 1;
    margin-bottom: 20px;
    .monri-input-label {
      font-size: 10px;
      text-transform: uppercase;
      width: 100%;
      margin-bottom: 10px;
      letter-spacing: 1.5px;
      color: #929397;
      white-space: pre-wrap;
    }
    .monri-input {
      flex: 1;
      border: none;
      box-shadow: none;
      border-bottom: 1px solid #eee;
      border-radius: 0;
      color: #3e3e3e;
      letter-spacing: 1px;
      padding: 6px 5px;
      // width: calc(100% - 10Px);
    }
    .monri-input::placeholder {
      color: #929397 !important;
      opacity: 0.5;
    }
  }
  .monri-input-flex {
    display: flex;
  }
  .monri-errors {
    font-size: 10px;
    color: #fc0d1b;
  }
}

.confirm-info {
  padding: 20px 30px;
  background-color: #f5f5f3;
  border-radius: 20px;
  margin: 30px;
}

.confirm-title {
  font-size: 32px;
  color: #999;
}

.confirm-price {
  font-size: 36px;
  // color: #fc0d1b;
}

.confirm-icon {
  display: flex;
  align-items: center;
  justify-content: center;

  & img {
    width: 40px;
    height: 40px;
    flex-shrink: 0;
  }

  & span {
    text-align: left;
    font-size: 28px;
    color: #999999;
  }
}

.confirm-payment {
  margin: 30px;

  &-label {
    padding: 10px 30px;
    font-size: 36px;
    color: #000;
    font-weight: bold;
  }

  &-item {
    display: flex;
    align-items: center;
    padding: 30px 20px;
    border-radius: 20px;
    background: #fff;
    margin-top: 20px;
    border: 1px solid #232323;

    & img {
      width: 40px;
      height: 40px;
    }

    &-info {
      display: flex;
      align-items: center;
      flex: 1;

      & .content {
        padding-left: 10px;
      }

      & .sub_title {
        font-size: 28px;
        color: #29cdf0;
      }
    }
    &-operate {
      display: flex;
      justify-content: flex-end;
      &-text {
        padding: 4px 12px;
        font-size: 28px;
        color: #fc0d1b;
      }
    }
  }
}

.bordermaincolor {
  border-color: @mainColor;
}

.confirm-btns {
  padding: 60px 56px 20px;
}

.confirm-btns .btn {
  margin-top: 20px;
}

.home-borrow-tips {
  font-size: 28px;
  color: #8b8b8b;
  padding: 30px 40px;
  text-align: center;
}
.home-pay-icon {
  padding: 0 60px;
  img {
    width: 100%;
  }
}
.home-info-card {
  display: flex;
  padding: 30px 20px;
  .home-info-list {
    flex: 1;
    .home-info-row {
      display: flex;
      color: #8b8b8b;
      font-size: 22px;
      align-items: center;
      padding: 10px 0;
      img {
        width: 28px;
        height: 28px;
        display: block;
        margin: 0 14px;
      }
    }
  }
}

.btn-paypal {
  background: #fec348 !important;
}

.btn-paypal img {
  width: 277px;
  height: 60px;
  margin: 18px 0;
}

.creditcard-input {
  margin: 48px 48px 80px;
  padding: 20px;
  border-radius: 20px;
  border: 1px solid #e4e7ed;
}

.creditcard-btn {
  margin: 48px;
  background: @mainColor;
  color: #fff;
}
.confirm-deposit-tips {
  margin: 30px 32px;
  padding: 20px 38px;
  color: #dd5c2d;
  background-color: rgba(221, 92, 45, 0.1);
  border-radius: 20px;
}
</style>
